import config from '../config/config';

export const isDev = config?.app?.stage && config.app.stage === 'dev';
export const isStaging = config?.app?.stage && config.app.stage === 'staging';
export const isProduction = config?.app?.stage && config.app.stage === 'prod';
export const isDemo = config?.app?.stage && config.app.stage === 'demo';
